// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success[data-v-1b77a10a] {
  color: green;
}
.error[data-v-1b77a10a] {
  color: red;
}
.warning[data-v-1b77a10a] {
  color: darkorange;
}
.upload-status .icon[data-v-1b77a10a] {
  font-size: 30px;
  line-height: 30px;
  vertical-align: middle;
}
.upload-status .icon[data-v-1b77a10a]:before {
  vertical-align: unset;
  color: inherit;
}
.dfNavButton.btn-file[data-v-1b77a10a] {
  border: 2px dashed #aaaaaa;
  border-radius: 5px;
}
.dfNavButton.btn-file input[type="file"][data-v-1b77a10a] {
  border: unset;
}
`, "",{"version":3,"sources":["webpack://./public/pages/elementTemplates/FileDef.3.vue","webpack://./../FileDef.3.vue"],"names":[],"mappings":"AACA;EACI,YAAA;ACAJ;ADEA;EACI,UAAA;ACAJ;ADEA;EACI,iBAAA;ACAJ;ADEA;EAEQ,eAAA;EACA,iBAAA;EACA,sBAAA;ACDR;ADEQ;EACI,qBAAA;EACA,cAAA;ACAZ;ADIA;EACI,0BAAA;EACA,kBAAA;ACFJ;ADAA;EAKQ,aAAA;ACFR","sourcesContent":["\n.success {\n    color: green;\n}\n.error {\n    color: red;\n}\n.warning {\n    color: darkorange;\n}\n.upload-status {\n    .icon {\n        font-size: 30px;\n        line-height: 30px;\n        vertical-align: middle;\n        &:before {\n            vertical-align: unset;\n            color: inherit;\n        }\n    }\n}\n.dfNavButton.btn-file {\n    border: 2px dashed #aaaaaa;\n    border-radius: 5px;\n\n    input[type=\"file\"] {\n        border: unset;\n    }\n}\n",".success {\n  color: green;\n}\n.error {\n  color: red;\n}\n.warning {\n  color: darkorange;\n}\n.upload-status .icon {\n  font-size: 30px;\n  line-height: 30px;\n  vertical-align: middle;\n}\n.upload-status .icon:before {\n  vertical-align: unset;\n  color: inherit;\n}\n.dfNavButton.btn-file {\n  border: 2px dashed #aaaaaa;\n  border-radius: 5px;\n}\n.dfNavButton.btn-file input[type=\"file\"] {\n  border: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
